import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Currency } from '@rd/types';
import { EMPTY, of } from 'rxjs';
import { switchMap, withLatestFrom } from 'rxjs/operators';
import { CoreState } from '../../../store/reducers';
import { getTenantBootstrapCurrencies } from '../../../tenant/store/selectors/tenant.selectors';
import * as actions from '../actions/currency.actions';

@Injectable()
export class CurrencyEffects {
  constructor(private store: Store<CoreState>, private actions$: Actions) {}

  changeSelectedCurrency$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.CurrencyActionTypes.CHANGE_CURRENCY),
      switchMap((action: actions.ChangeCurrency) => {
        return of(new actions.LoadCurrencySuccess(action.payload));
      }),
    ),
  );

  changeSelectedCurrencyByCode$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.CurrencyActionTypes.CHANGE_CURRENCY_BY_CODE),
      withLatestFrom(
        this.store.select((state) => getTenantBootstrapCurrencies(state)),
      ),
      switchMap(
        ([action, currencies]: [
          actions.ChangeCurrencyByCode,
          Currency[] | null,
        ]) => {
          if (!currencies) {
            return EMPTY;
          }

          const currency = currencies.find(
            (currencyObj) => currencyObj.code === action.payload,
          );

          if (currency) {
            return of(new actions.ChangeCurrency(currency));
          } else {
            return EMPTY;
          }
        },
      ),
    ),
  );
}
